import { combineReducers } from 'redux';
import { ConfigurationState } from '../model/ConfigurationModel';
import { BadgeState, MapsState } from '../model/GraphicModel';
import { AlarmState, alarmReducer } from './alarm/reducer';
import { badgeReducer } from './badge/reducer';
import { CommonState, commonReducer } from './common/reducer';
import { configurationReducer } from './configuration/reducer';
import { ControllerState, controllerReducer } from './deviceControl/controller/reducer';
import { ControlZonesState, controlZonesReducer } from './deviceControl/controlZones/reducer';
import { DeviceControlState, deviceControlReducer } from './deviceControl/reducer';
import { EnrollmentState, enrollmentReducer } from './enrollment/reducers';
import { EventState, eventReducer } from './event/reducer';
import { mapReducer } from './graphic/reducers';
import { HelpState, helpReducer } from './help/reducers';
import { PhotoCallUpState, photoCallUpReducer } from './photocallup/reducers';
import { StatusViewerState, statusViewerReducer } from './statusViewer/reducers';

export interface RootReducer {
	photoCallUpReducer: PhotoCallUpState;
	enrollmentReducer: EnrollmentState;
	configurationReducer: ConfigurationState;
	deviceControlReducer: DeviceControlState;
	commonReducer: CommonState;
	controllerReducer: ControllerState;
	controlZonesReducer: ControlZonesState;
	statusViewerReducer: StatusViewerState;
	eventReducer: EventState;
	alarmReducer: AlarmState;
	mapReducer: MapsState;
	badgeReducer: BadgeState;
	helpReducer: HelpState;
}

const rootReducer = combineReducers({
	photoCallUpReducer,
	enrollmentReducer,
	configurationReducer,
	deviceControlReducer,
	commonReducer,
	controllerReducer,
	controlZonesReducer,
	statusViewerReducer,
	eventReducer,
	alarmReducer,
	mapReducer,
	badgeReducer,
	helpReducer,
});

export { rootReducer };
